import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chinh-sach-bao-mat',
  templateUrl: './chinh-sach-bao-mat.component.html',
  styleUrls: ['./chinh-sach-bao-mat.component.css']
})
export class ChinhSachBaoMatComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
